<template>
  <div>
    <div class="card" id="titulo">
      <div class="card-header" @click="toggle = !toggle">
        <div class="row headerCard">
          <div class="col-md-2">
            <i class="fas fa-cube mr-2"></i>
            <p class="d-inline fw-bold">NCM {{ monitorada.ncm }}</p>
          </div>
          <div class="col-md-6 col-lg-7">
            <p class="d-inline fs-12">{{ monitorada.descricao }}</p>
          </div>
          <div class="col-md-3 col-lg-2" @click="maisInformacoes()">
            <img
              src="https://www.lefisc.com.br/monitoramentoncm/img/info2.png"
              class="img-fluid imagemMI"
              alt
            />
          </div>
          <div class="col-md-1">
            <span class="imagemMF">
              <!-- - {{ item.hora }}-->
              <span class="icone fs-20" v-if="!toggle">
                <i class="fas fa-plus"></i>
              </span>
              <span class="icone fs-20" v-if="toggle">
                <i class="fas fa-minus"></i>
              </span>
            </span>
          </div>
        </div>
      </div>

      <transition name="exibir">
        <div class="collapse show" aria-labelledby="cabecalho alterações" v-if="toggle">
          <div class="card-body">
            <p style="margin-bottom:0px" v-if="monitorada.vPISCOFINS">
              <strong>PIS/COFINS:</strong>
              <br />
              <span v-html="monitorada.piscofins"></span>
            </p>
            <p style="margin-bottom:0px" v-if="monitorada.vIPI">
              <strong>IPI:</strong>
              {{ monitorada.ipi }}
            </p>
            <p style="margin-bottom:0px" v-if="monitorada.vICMS">
              <strong>ICMS:</strong>
              <a
                href="#"
                @click.prevent.stop
                class="ml-1 d-inline"
                v-b-modal="monitorada.ncm"
              >Consultar</a>
            </p>
            <p style="margin-bottom:0px">
              <strong>Reduções:</strong>
              <a
                href="#"
                @click.prevent.stop
                class="ml-1 d-inline"
                v-b-modal="monitorada.ncm.concat('b')"
              >Consultar</a>
              </p>
               <p style="margin-bottom:0px">
               <strong>Isenções:</strong>
              <a
                href="#"
                @click.prevent.stop
                class="ml-1 d-inline"
                v-b-modal="monitorada.ncm.concat('i')"
              >Consultar</a>
               </p>
            <div>
              <hr class="hr" />
              <div v-for="ex in monitorada.ex" :key="ex.idExcecao">
                <excecao :item="ex" />
              </div>
            </div>

            <a class="mb-2 text-right" style="margin-top: 10px">
              <div class="btn btn-labeled btn-info text-right d-inline-block">
                <transition name="exibir">
                  <button
                    class="btn btn-info"
                    type="button"
                    v-b-modal="monitorada.ncm + 'confirmacao'"
                  >
                    <span>
                      Desvincular
                      <div
                        class="spinner-border text-white loading ml-2"
                        v-if="loadingMonitoramento"
                        role="status"
                      >
                        <span class="sr-only">Aguarde...</span>
                      </div>
                    </span>
                  </button>
                </transition>
              </div>
            </a>
          </div>
        </div>
      </transition>

      <!-- Modal -->
      <b-modal :id="monitorada.ncm" centered title="Alíquotas do ICMS" size="lg">
        <div slot="default">
          <table class="table w-100">
            <div class="w-100">
              <tr class="row">
                <th class="col-md-6">Estado</th>
                <th class="col-md-6">NCM</th>
              </tr>
            </div>
            <div v-for="(aliquota, index) in monitorada.aliquotas" :key="index" class="w-100">
              <hr class="hr" />
              <tr class="row">
                <div class="col-md-12">
                  <div class="row">
                    <td class="col-md-6">{{ aliquota.estado }}</td>
                    <td class="col-md-6">{{ aliquota.icms }}%</td>
                    <table class="table" v-if="aliquota.notas">
                      <td colspan="2" style="font-size:10px" class="w-100">
                        <b>Nota Lefisc:</b>
                        {{ aliquota.notas }}
                      </td>
                    </table>
                  </div>
                </div>
                <hr class="hr" />
              </tr>
            </div>
          </table>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button
            variant="info"
            size="sm"
            class="float-right"
            @click="$bvModal.hide(`${monitorada.ncm}`)"
          >Fechar</b-button>
        </div>
      </b-modal>
      <!-- Modal FIM -->
      <!-- Modal Isencoes -->       
      <b-modal :id="monitorada.ncm.concat('i')" title="Isenções" size="lg">
        <div slot="default">   
          <table class="table w-100">
            <div class="w-100">
              <tr class="row">
                <th class="col-md-2">Estado</th>
                <th class="col-md-10">Nota</th>
              </tr>
            </div>
            <div v-for="(aliquota, index) in moniDados.isencao" :key="index" class="w-100">
              <hr class="hr" />
              <tr class="row">
                <div class="col-md-12">
                  <div class="row">
                    <td class="col-2" v-html="aliquota.uf"></td>
                    <td class="col-10" v-if="aliquota.notas" v-html="aliquota.notas"></td>
                    <td style="display: flex; padding: 0px; align-items: center;padding-left: 12px;" class="col-10" v-else ><div class="vazio"> <span> {vazio}</span></div></td>
                  </div>
                </div>
              </tr>
            </div>
          </table>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button
            variant="info"
            size="sm"
            class="float-right"
            @click="$bvModal.hide(`${monitorada.ncm.concat('i')}`)"
          >Fechar</b-button>
        </div>
      </b-modal> 
      <!-- Modal FIM -->
      <!-- Modal Beneficios --> 
       <b-modal :id="monitorada.ncm.concat('b')" title="Reduções" size="lg">
        <div slot="default">   
          <table class="table w-100">
            <div class="w-100">
              <tr class="row">
                <th class="col-md-2">Estado</th>
                <th class="col-md-10">Nota</th>
              </tr>
            </div>
            <div v-for="(aliquota, index) in moniDados.beneficios" :key="index" class="w-100">
              <hr class="hr" />
              <tr class="row">
                <div class="col-md-12">
                  <div class="row">
                    <td class="col-2" v-html=" aliquota.uf"></td>
                    <td class="col-10" v-if="aliquota.notas" v-html="aliquota.notas"></td>
                    <td style="display: flex; padding: 0px; align-items: center;padding-left: 12px;" class="col-10" v-else ><div class="vazio"> <span> {vazio}</span></div></td>
                  </div>
                </div>
              </tr>
            </div>
          </table>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button
            variant="info"
            size="sm"
            class="float-right"
            @click="$bvModal.hide(`${monitorada.ncm.concat('b')}`)"
          >Fechar</b-button>
        </div>
      </b-modal>
      <!-- Modal FIM -->
    </div>
    <!-- Modal Confirmação -->
    <b-modal
      :id="monitorada.ncm + 'confirmacao'"
      no-close-on-backdrop
      hide-header
      hide-footer
      centered
    >
      <div v-if="etapa == 0">
        <div class="iconeContent text-center m-auto">
          <i class="fas fa-exclamation danger"></i>
        </div>
        <h2 class="titulo">Confirmar desvinculação de NCM?</h2>
        <p class="lead text-muted alerta text-center">
          Ao desvincular uma NCM você deixará de receber as atualizações sobre ela.
          <br />Tem certeza?
          <i class="far fa-sad-tear"></i>
        </p>
        <div class="row text-center">
          <div class="col-6">
            <button
              class="cancel btn btn-lg btn-default"
              @click="$bvModal.hide(monitorada.ncm + 'confirmacao')"
            >Não, me mantenha atualizado!</button>
          </div>
          <div class="col-6">
            <button
              class="confirm btn btn-lg btn-danger"
              @click="confirmacao = true, desvincular()"
            >Sim, desvincular NCM!</button>
          </div>
        </div>
      </div>
      <div class="text-center m-auto" v-if="loadingMonitoramento && etapa == 2">
        <div class="spinner-border text-primary iconeLoading" role="status">
          <span class="sr-only">Aguarde...</span>
        </div>
      </div>

      <div v-if="etapa == 3" class="text-center">
        <p class="lead text-muted alerta fs-15">NCM desvinculada com Sucesso!</p>
        <i class="far fa-check-circle iconeSucesso text-success"></i>
        <div class="mt-4 text-right">
          <button class="btn btn-primary" @click="$bvModal.hide(monitorada.ncm + 'confirmacao')">OK</button>
        </div>
      </div>
    </b-modal>
    <!-- Modal Confirmação FIM -->
  </div>
</template>

<script>
import serviceMonitoramento from "../services/ServiceMonitoramentoAlteracoes";
import serviceCookie from "../services/ServiceCookie";
import excecao from "../components/historico/excecao";
import config from '../services/config.js'
export default {
  props: {
    monitorada: {
      type: Object,
      required: true
    }
  },
  components: {
    excecao
  },
  data() {
    return {
      idMonitoramento: null,
      loadingMonitoramento: false,
      idCliente: null,
      confirmacao: false,
      etapa: 0,
      toggle: false,
      moniDados:[]
    };
  },

  async created() {
    let idCliente = await serviceCookie.getCookie("idCliente");
    if (idCliente.length > 0) //idCliente = idCliente.substring(3);

    await serviceMonitoramento
      .estaMonitorando(this.monitorada.ncm, idCliente)
      .then(
        res => {
          this.idmonitoramento = res;
        },
        err => {
          console.error(err);
        }
      );

    await this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      if (modalId == this.monitorada.ncm + "confirmacao") this.etapa = 0;
    });
  },

  methods: {
    async getBenficiosIsencoes(){    
      this.moniDados = await config.getDadosNcm(this.monitorada.ncm)      
    },
    async desvincular() {
      this.etapa = 1;
      if (this.confirmacao) {
        this.loadingMonitoramento = true;
        this.etapa = 2;
        await serviceMonitoramento
          .DeixarMonitoramento(this.idmonitoramento)
          .then(
            res => {
              this.loadingMonitoramento = false;
              if (res == "Você deixou de monitorar a NCM.") {
                this.idmonitoramento = 0;
                this.etapa = 3;
                this.$emit("excluirmonitorada", this.monitorada.ncm);
              }
            },
            err => {
              console.error(err);
              this.loadingMonitoramento = false;
            }
          );
      }
    },

    maisInformacoes() {
      this.$router.push({
        name: "Histórico",
        params: { ncm: this.monitorada.ncm }
      });
    },

    fecharTodos(elemento) {
      if (elemento) elemento = false;
      else {
        this.alteracoes.forEach(elemento => {
          elemento.toggle = false;
        });
      }
    }
  },
  mounted(){   
    this.getBenficiosIsencoes()
  }
};
</script>

<style scoped>
.fs-20 {
  font-size: 15px;
  color: gray;
}
.icone {
  width: 10px;
  padding-right: 10px;
  margin-left: 10px;
  display: inline-block;
}

.loading {
  height: 16px;
  width: 16px;
  font-size: 10px;
}

.exibir-enter,
.exibir-leave-to {
  min-height: 0;
  max-height: 0;
  opacity: 0;
}

.exibir-enter-to,
.exibir-leave {
  min-height: 1;
  max-height: 700px;
}

.exibir-leave-active,
.exibir-enter-active {
  transition: all 0.4s;
}

.headerCard p {
  color: black;
}
.fs-12 {
  font-size: 12px;
}
.card-header {
  cursor: pointer;
}

.fw-bold {
  font-weight: bold;
}

.iconeContent {
  height: 100px;
  width: 100px;
}

.danger {
  border: 3px solid #dc3545;
  border-radius: 100%;
  width: 100px;
  height: 100px;
  font-size: 60px;
  color: #dc3545;
  line-height: 100px;
}

.hr {
  border-bottom: 1px solid #eceff8;
  border-top: 0 none;
  margin: 0px 0;
  padding: 0;
}

.titulo {
  font-size: 20px;
  text-align: center;
  font-weight: bold;
  margin-top: 20px;
}

.alerta {
  font-size: 12px;
  margin-top: 10px;
}

.iconeLoading {
  font-size: 20px;
  width: 50px;
  height: 50px;
}

.fs-15 {
  font-size: 15px;
}

@keyframes sucesso {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.iconeSucesso {
  font-size: 50px;
  animation-name: sucesso;
  animation-delay: 0.3s;
  animation-duration: 0.7s;
  animation-fill-mode: both;
}

.imagemMF {
  float: right;
  margin-right: 10px;
  line-height: 0;
}

@media (max-width: 375px) {
  .img-fluid {
    margin-bottom: 20px;
    height: 35px;
    margin: auto;
    margin-top: 10px;
  }
  .imagemMI {
    height: 35px;
  }
}

@media (min-width: 376px) and (max-width: 424px) {
  .img-fluid {
    margin-bottom: 20px;
    height: 35px;
    margin: auto;
    margin-top: 10px;
  }

  .imagemMI {
    height: 20px;
    padding-top: 20px;
  }
}

@media (min-width: 425px) and (max-width: 768px) {
  .img-fluid {
    margin-bottom: 20px;
    height: 35px;
    margin: auto;
    margin-top: 10px;
  }
  .imagemMF {
    padding-top: 20px;
  }
}
</style>